import {
  Dashboard as DashboardIcon,
} from '@mui/icons-material';

import { IMenuItem } from '../types';
import { ROUTES } from './routes';

export const MENU_LIST: IMenuItem[] = [
  {
    route: ROUTES.dashboard,
    literal: 'menu.dashboard',
    Icon: DashboardIcon,
  },
];
